export class InvoiceHistory {
  dateOfBilling!: string;
  documentKey?: string;
  dunningCycleCode?: string;
}
